export default "__VITE_ASSET__BLyawaFm__"